export enum ConfigurationProjectVisibility{
    Default = 0,
    Private = 1,
    Public = 2,
    PublicByGroup = 3
}